import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Toasted from 'vue-toasted'
import VueSplide from '@splidejs/vue-splide'
import 'tailwindcss/tailwind.css'
import './styles/global.css'
import VueMasonry from 'vue-masonry-css'
import VueI18n from 'vue-i18n'
import messages from './locales'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueMasonry)
axios.defaults.baseURL = process.env.VUE_APP_BASE_PATH
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(Toasted)
Vue.use(VueSplide)
Vue.use(VueI18n)

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
    v: 'weekly'
  }
})

const i18n = new VueI18n({
  locale: 'id', // default locale
  fallbackLocale: 'en',
  messages
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
